import { useMatch, useParams } from 'react-router-dom';
import { useMemo } from 'react';

const useRunId = () => {
  // only use when inside a run

  // handles where edge case for AutomationPageWrapper
  const runMatch = useMatch('/automations/:automationId/runs/:runId/*');
  const resultMatch = useMatch('/automations/:automationId/results/:runId/*');

  const { runId } = useParams<{ runId: string }>();

  return useMemo(
    () => runMatch?.params.runId ?? resultMatch?.params.runId ?? runId!,
    [runMatch, resultMatch, runId],
  );
};
export default useRunId;
